import { useState, type ReactNode } from "react";

import { PALETTE } from "../lib/correlation";

/** A colour swatch that opens the palette when clicked. */
export function ColorPicker({
  value,
  onChange,
  label,
  disabled,
  compact,
}: {
  value: string;
  onChange: (value: string) => void;
  label: ReactNode;
  disabled?: boolean;
  /** Hanya kotak warnanya, tanpa baris nama.
   *
   *  Dipakai di baris yang sudah menyebutkan namanya sendiri — daftar kurva di
   *  penyunting track — tempat mengulang nama itu di sebelah kotak warna
   *  memakan satu baris penuh untuk mengatakan apa yang sudah tertulis di
   *  atasnya. Namanya tetap hidup sebagai label bantu bagi pembaca layar. */
  compact?: boolean;
}) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 4, minWidth: 0 }}>
      <div style={{ display: compact ? "contents" : "flex", alignItems: "center", gap: 7 }}>
        <button
          type="button"
          aria-label={`Change colour ${typeof label === "string" ? label : ""}`}
          disabled={disabled}
          onClick={() => setOpen(!open)}
          style={{
            width: 16,
            height: 16,
            flex: "none",
            background: value,
            border: "1px solid var(--border-control)",
            borderRadius: 3,
            cursor: disabled ? "default" : "pointer",
            opacity: disabled ? 0.55 : 1,
            padding: 0,
          }}
        />
        {!compact && (
          <span
            style={{
              font: "400 10px var(--font-mono)",
              color: "var(--ink-3)",
              flex: 1,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {label}
          </span>
        )}
      </div>
      {open && (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 4 }}>
          {PALETTE.map((colour) => (
            <button
              key={colour}
              type="button"
              aria-label={colour}
              onClick={() => {
                onChange(colour);
                setOpen(false);
              }}
              style={{
                height: 15,
                background: colour,
                border:
                  colour.toLowerCase() === value.toLowerCase()
                    ? "2px solid var(--ink)"
                    : "1px solid var(--border-control)",
                borderRadius: 3,
                cursor: "pointer",
                padding: 0,
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
}
